import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { formatDateVerbose } from '@air/utilities';

/**
 * This function returns an array of metadata extracted from the given version.
 *
 * @param version - The version to get the meta for
 * @returns An array of metadata
 */
export const getVersionMeta = (version: Clip | PublicClip) => {
  const metaArray = [];

  if (version.ext) {
    metaArray.push(version.ext.toUpperCase());
  }

  if (version.createdAt) {
    metaArray.push(formatDateVerbose(version.createdAt));
  }

  return metaArray;
};
